import { api } from '../../lib/api-client';

export interface InboxItem {
  uid: string;
  templateCode: string;
  entityUid: string | null;
  values: Record<string, string | number | null>;
  createdAt: string;
  readAt: string | null;
}

export interface InboxPage {
  items: InboxItem[];
  nextCursor: string | null;
  hasMore: boolean;
}

export const listInbox = (cursor?: string): Promise<InboxPage> =>
  api<InboxPage>(`/notifications/inbox${cursor !== undefined ? `?cursor=${encodeURIComponent(cursor)}` : ''}`);

export const unreadCount = (): Promise<{ unread: number }> =>
  api<{ unread: number }>('/notifications/inbox/unread-count');

export const markRead = (uid: string): Promise<InboxItem> =>
  api<InboxItem>(`/notifications/inbox/${uid}/read`, { method: 'POST' });

/** `upTo` is the newest alert on screen, so one that arrived since stays unread. */
export const markAllRead = (upTo: string): Promise<{ marked: number }> =>
  api<{ marked: number }>('/notifications/inbox/read-all', { method: 'POST', body: { upTo } });

/**
 * Where tapping an alert takes you. Alerts raised before the inbox existed
 * carry no record id, so the ones that need one open nothing.
 */
export function alertTarget(item: InboxItem): string | null {
  switch (item.templateCode) {
    case 'case.response_overdue':
    case 'case.resolve_overdue':
      return item.entityUid !== null ? `/cases/${item.entityUid}` : '/cases';
    case 'follow_up.overdue':
      return '/follow-ups';
    case 'lead.follow_up_overdue':
    case 'lead.first_response_overdue':
      return item.entityUid !== null ? `/leads/${item.entityUid}` : '/leads';
    case 'financing.decision_overdue':
      return '/financing';
    case 'parts.stock_drift':
      return '/warehouse';
    case 'accounting.digest':
      return '/accounts';
    case 'analytics.exceptions':
      return '/insights?tab=exceptions';
    default:
      return null;
  }
}
